import createFetchClient from 'openapi-fetch'
import createClient from 'openapi-react-query'

import type { paths } from '../gen/tintin-delivery-service-schema'
import config from './req.config'
export type { paths as DeliveryPaths }

export const deliveryServiceReq = createFetchClient<paths>({
  ...config,
})

export const deliveryServiceQuery = createClient<paths>(deliveryServiceReq)
